import React from "react";
import { CgPlayListRemove } from "react-icons/cg";
import { AiOutlineCheck } from "react-icons/ai";

const DetalhamentoFase = ({ data }) => {
  if (data.atividades.length > 0) {
    return (
      <div className="text-left m-4">
        <h5>Atividades Associadas</h5>
        <ul className="list-group">
          {data.atividades.map((item) => (
            <li className="list-group-item" key={item.nome}>
              <AiOutlineCheck className="text-success" />
              &nbsp;
              {item.nome}
            </li>
          ))}
        </ul>
      </div>
    );
  }

  return (
    <div className="text-center m-4">
      <CgPlayListRemove className="text-danger" />
      <span className="text-muted">&nbsp;Sem atividades associadas</span>
    </div>
  );
};

export default DetalhamentoFase;
